import { ExponeaUiButton } from '@kaltura-ott/tvpil-shared';

export const NORMAL_TYPE = 'normal';

export function getNormalButton(arr: ExponeaUiButton[]) {
  return arr.find(({ type }) => type === NORMAL_TYPE);
}
